import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { P2WebpageGet, WebPageService } from '@app/services/web-page.service';

@Component({
    selector: 'tt-p2-webpage-edit',
    templateUrl: './p2-webpage-edit.component.html',
    styleUrls: ['./p2-webpage-edit.component.css'],
    standalone: false,
})
export class P2WebpageEditComponent implements OnInit, OnChanges {
    @Input() public p2WebpageKeyno?: string;
    @Input() public inline = false;
    @Output() public onSave = new EventEmitter<void>();

    public page?: P2WebpageGet;
    public lockedSave = false;
    public readonly tabletSize: MediaQueryList;

    private navigator?: TTViewNavigator;

    constructor(
        private webPage: WebPageService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) navigator?: TTViewNavigator,
    ) {
        this.tabletSize = layout.getMediaQueries().tablet;
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.lockedSave) return;

        this.lockedSave = true;
        try {
            await this.webPage.saveP2Webpage(this.page);
            if (this.tabletSize.matches && this.inline) {
                this.onSave.emit();
            } else {
                await this.navigator?.back();
            }
        } catch {
            // Keep the editor open and unlock saving so the user can retry.
        } finally {
            this.lockedSave = false;
        }
    }

    public ngOnInit(): void {
        if (!this.p2WebpageKeyno) {
            const routeKeyno = this.navigator?.params['p2_webpage_keyno'];
            if (routeKeyno !== undefined && routeKeyno !== null) {
                this.p2WebpageKeyno = `${routeKeyno}`;
                void this.loadPage(this.p2WebpageKeyno);
            }
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        const keyno = changes['p2WebpageKeyno']?.currentValue;
        if (keyno !== undefined && keyno !== null && keyno !== '') {
            this.p2WebpageKeyno = `${keyno}`;
            void this.loadPage(this.p2WebpageKeyno);
        }
    }

    private async loadPage(keyno: string): Promise<void> {
        this.page = await this.webPage.getP2Webpage({ p2_webpage_keyno: keyno });
    }
}
